<template>
    <div class="main">
        <transition>
            <div class="new-checkout">
                <user-checkout-summary class="new-checkout--nav"  v-if="showNewCheckoutSummary"/>
                <div class="new-checkout--content">
                    <router-view/>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import UserCheckoutSummary from '@/components/partials/register/UserCheckoutSummary';

export default {
    name: 'Register',
    components: {
        UserCheckoutSummary,
    },
    computed: {
        showNewCheckoutSummary() {
            return this.$route.name !== 'register.email';
        },
    },
    mounted() {
        this.$store.dispatch('cookies/mountStripe');
    },
};
</script>

<style lang="scss" scoped>
.new-checkout {
    &--content {
        padding: 32px;
    }
    @media(min-width: 640px) {
        display: flex;
        gap: 10px;
        flex-direction: row-reverse;
        justify-content: center;
        max-width: 1400px;
        width: 90%;
        margin: 70px auto;
        &--nav {
            width: 100%;
            max-width: 450px;
            margin: 30px auto;
            margin-right: auto;
        }
        &--content {
            width: 65%;
            min-width: 350px;
            max-width: 550px;
            margin: 0 auto;
        }
    }
}
</style>
